import { useFormik } from "formik";
import { isEmpty } from "lodash-es";
import React, { useEffect, useRef } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { trackingViews } from "../../constants/tracking";
import { trackingFormModel } from "../../helpers/tracking/formModel";
import { quickAccessTrackingValidationSchema } from "../../helpers/tracking/validationSchema";
import { isIframed } from "../../helpers/utils";
import * as shippingService from "../../store/shipping/actions";

import SubmitBtn from "../form/SubmitBtn";

const MARKETINGSITE = process.env.REACT_APP_MARKETING_SITE_URL;

const {
  formFields: { trackingNumbers },
} = trackingFormModel;

const Btn2 = styled(Button)`
  color: var(--submarine);
  &:hover {
    color: var(--iron);
  }
`;

const FormStyled = styled(Form)`
  padding: 1.5rem 1rem;
  @media (min-width: 768px) {
    padding: 32px 48px;
  }
`;

const TrackingForm = ({
  // setView = () => {},
  trackingNum = "",
  setTrackingNum = () => {},
  view,
}) => {
  const dispatch = useDispatch();
  const authenticated = useSelector(({ auth }) => auth.isLoggedIn);
  const trackingNumFieldRef = useRef();
  const { push } = useHistory();

  const onTrack = () => {
    if (!isEmpty(trackingNum)) {
      dispatch(
        shippingService.searchTracking(
          trackingViews.trackingResults,
          trackingNum
        )
      );
    }
  };

  const { handleBlur, values, setFieldValue, errors, handleSubmit } = useFormik(
    {
      initialValues: {
        [trackingNumbers.name]: "",
      },
      validationSchema: quickAccessTrackingValidationSchema,
      onSubmit: onTrack,
    }
  );

  const fieldError = errors[trackingNumbers.name];

  useEffect(() => {
    if (
      !document.body.classList.contains("auth-open") &&
      trackingNumFieldRef.current
    ) {
      trackingNumFieldRef.current.focus();
    }
  }, []);

  const handleChangeTrackingNum = (e) => {
    const value = e.target.value;
    setTrackingNum(value);
    setFieldValue(trackingNumbers.name, value);
  };

  const handleTrackMultiple = (e) => {
    e.preventDefault();
    if (isIframed) {
      window.parent.postMessage({ redirect: "/tracking" }, MARKETINGSITE);
    } else if (!isIframed && !authenticated) {
      window.location.href = `${MARKETINGSITE}/tracking`;
    } else {
      push("/account-tracking");
    }
  };

  return (
    <FormStyled
      className="text-white"
      id="quick-tracking-form"
      onSubmit={handleSubmit}
    >
      <Form.Label as="h5" className="mb-8px">
        Track your package
        <Btn2
          onClick={handleTrackMultiple}
          variant="link"
          className="float-right btn-pure-link text-body-smaller"
        >
          Track multiple packages
        </Btn2>
      </Form.Label>
      <InputGroup className="input-group-merge surround-btn-slant appended">
        <Form.Control
          // className="dark-back"
          placeholder="Enter tracking number"
          aria-label="Tracking number"
          name={trackingNumbers.name}
          value={values[trackingNumbers.name]}
          onBlur={handleBlur}
          onChange={handleChangeTrackingNum}
          ref={trackingNumFieldRef}
          isInvalid={!!fieldError}
        />
        <InputGroup.Append>
          <SubmitBtn className="btn-slant">Track</SubmitBtn>
        </InputGroup.Append>
        {!!fieldError && (
          <Form.Control.Feedback as="span" type="invalid">
            {fieldError}
          </Form.Control.Feedback>
        )}
      </InputGroup>
    </FormStyled>
  );
};

export default TrackingForm;
